import './styles/null.scss';
import './styles/App.scss';
import './styles/vars.scss';
import './styles/toast.scss';
import './fonts/Fontspring-DEMO-integralcf-bold.otf';
import { AppRouter } from "./app/AppRouter";
import { Provider } from "react-redux";
import store from "./app/store";
import axios from "axios";
import { SkeletonTheme } from "react-loading-skeleton";
import { WebAppProvider } from "@vkruglikov/react-telegram-web-app";
import { YMInitializer } from 'react-yandex-metrika';
import { postEvent } from '@telegram-apps/bridge';
import { ConfigProvider } from 'antd';
import { useEffect } from 'react';
import { TelegramProvider } from './contexts/TelegramContext';
import { isTelegramEnv } from './utils/isTelegramEnv';
import { AppToaster } from './components/AppToaster/AppToaster';

function App() {
  axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('token')}`;

  useEffect(() => {
    if (isTelegramEnv() && window.location.hash.slice(1)) {
      postEvent('web_app_expand');
      postEvent('web_app_request_fullscreen');
      postEvent('web_app_setup_swipe_behavior', { "allow_vertical_swipe": false });
    }
  }, []);

  return (
    <WebAppProvider>
      <TelegramProvider>
      <Provider store={store}>
        <SkeletonTheme baseColor="#2C2C2E" highlightColor="#3A3A3C">
          <ConfigProvider
            theme={{
              components: {
                Select: {
                  selectorBg: '#1C1C1E',
                  activeBorderColor: '#1C1C1E',
                  optionSelectedBg: '#1C1C1E'
                },
              },
            }}
          ></ConfigProvider>
          <div className="App">
            <YMInitializer accounts={[97132345]} options={{ webvisor: true }} version="2" />
            <AppRouter />
            <AppToaster />
          </div>
        </SkeletonTheme>
      </Provider>
      </TelegramProvider>
    </WebAppProvider>
  );
}

export default App;
